import moment from "moment";
import { insurancePolicyTypes } from "../../../ABLTC/SubComponents/SelectOptions";
import { AccountTypes } from "../../../../Common/Constant";
import { policyOwnerships } from "../Helpers/Constants";
import { SESSION_STORAGE_ABLTC_OBJECT_KEY, getSessionStorageItem } from "../../../../../sessionStorage";

const handleCheckNull = (value) => {
    return value === null || value === undefined ? '' : value;
}

const getOwnerDetailsFromId = (value, ownerList) => {
    return ownerList !== undefined && ownerList.length !== 0 && ownerList.find(item => item.covrGeneratedID === value);
}

const getInsuredPrefillData = (insuredData) => {
    const insuredDetails = {
        proposedInsuredFirstName: handleCheckNull(insuredData.firstName),
        proposedInsuredMiddleInitial: handleCheckNull(insuredData.middleName),
        proposedInsuredLastName: handleCheckNull(insuredData.lastName),
        gender: handleCheckNull(insuredData.gender),
        birthdate: handleCheckNull(insuredData.dateOfBirth) === '' ? '' : moment(insuredData.dateOfBirth).format('MM/DD/YYYY'),
        state: handleCheckNull(insuredData.state),
        isOther: false,
        middleNameDisable: !!handleCheckNull(insuredData.middleName),
    }
    return insuredDetails;
}

const handleSetOtherOwnerInInsuredInfo = (index, fullFormState, insuredInfoDefaultState) => {
    return fullFormState.pages.insuredBasicInfo.insuredInfo[index] = insuredInfoDefaultState.insuredInfo[0];
}


export const PrefillABLTCInsuredInfo = (fullForm, clientData, formState, ownerList, insuredInfoDefaultState) => {
    const sessionData = getSessionStorageItem(SESSION_STORAGE_ABLTC_OBJECT_KEY);
    const sessionFormState = sessionData && sessionData.pages && sessionData.pages.retrieveAccount;
    const isPrefillBasedOnAccountType = [AccountTypes.INDIVIDUAL, AccountTypes.JOINT, AccountTypes.PARTNERSHIP, AccountTypes.UNINCORPORATED, AccountTypes.RPM].includes(clientData.accountType.toLowerCase());
    if (isPrefillBasedOnAccountType) {
        if (formState.insurancePolicyType === insurancePolicyTypes.INDIVIDUAL) {
            if (fullForm.pages.insuredBasicInfo.insuredInfo.length > 1) {
                fullForm.pages.insuredBasicInfo.insuredInfo.pop();
            }
            if (formState.isProposedInsured && (!sessionFormState || sessionFormState.isProposedInsured !== formState.isProposedInsured || sessionFormState.owner !== formState.owner)) {
                if (formState.isProposedInsured === 'false') {
                    handleSetOtherOwnerInInsuredInfo(0, fullForm, insuredInfoDefaultState);
                }
                if (formState.isProposedInsured === 'true') {
                    let insuredID = formState.owner;

                    if (clientData.accountType.toLowerCase() === AccountTypes.JOINT && formState.policyOwnership === policyOwnerships.JOINT) {
                        insuredID = formState.insured;
                    }
                    const selectedInsuredDetails = insuredID && getOwnerDetailsFromId(insuredID, ownerList);
                    const insuredDetails = selectedInsuredDetails && getInsuredPrefillData(selectedInsuredDetails);
                    fullForm.pages.insuredBasicInfo.insuredInfo[0] = insuredDetails;
                }
            }
        }
        else if (formState.insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP) {
            if (fullForm.pages.insuredBasicInfo.insuredInfo.length <= 1) {
                fullForm.pages.insuredBasicInfo.insuredInfo.push(insuredInfoDefaultState.insuredInfo[0])
            }
            if (formState.insured && (!sessionFormState || sessionFormState.insured !== formState.insured)) {
                if (formState.insured !== 'Other') {
                    const firstInsuredDetails = getOwnerDetailsFromId(formState.insured, ownerList);
                    const insuredDetails = firstInsuredDetails && getInsuredPrefillData(firstInsuredDetails);
                    fullForm.pages.insuredBasicInfo.insuredInfo[0] = insuredDetails;
                }
                else {
                    handleSetOtherOwnerInInsuredInfo(0, fullForm, insuredInfoDefaultState);
                }
            }
            if (formState.secondInsured && (!sessionFormState || sessionFormState.secondInsured !== formState.secondInsured)) {
                if (formState.secondInsured !== 'Other') {
                    const secondInsuredDetails = getOwnerDetailsFromId(formState.secondInsured, ownerList);
                    const insuredDetails = secondInsuredDetails && getInsuredPrefillData(secondInsuredDetails);
                    fullForm.pages.insuredBasicInfo.insuredInfo[1] = insuredDetails;
                }
                else {
                    handleSetOtherOwnerInInsuredInfo(1, fullForm, insuredInfoDefaultState);
                }
            }
        }
    }
    else if (clientData.accountType.toLowerCase() === AccountTypes.TRUST || clientData.accountType.toLowerCase() === AccountTypes.LIMITED_LIABILITY) {
        if (formState.insurancePolicyType === insurancePolicyTypes.INDIVIDUAL) {
            if (fullForm.pages.insuredBasicInfo.insuredInfo.length > 1) {
                fullForm.pages.insuredBasicInfo.insuredInfo.pop();
            }
        }
        else if (formState.insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP) {
            if (fullForm.pages.insuredBasicInfo.insuredInfo.length <= 1) {
                fullForm.pages.insuredBasicInfo.insuredInfo.push(insuredInfoDefaultState.insuredInfo[0])
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/RetrieveAccount/SubComponents/PrefillABLTCInsuredInfo.js